<script>
import '../../vendors/font-awesome.min.css'

export default {
    props: [],
    data: function(){
        return  {

        };
    },
    computed: {

    },
    mounted(){
      console.log("Private area component loaded")
    },
    methods: {

    }
};

</script>

<template>

</template>